<template>
  <div
    :id="id"
    class="modal fade"
    role="dialog"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div
        class="modal-content"
        :class="{ 'container-fluid': fluid, 'background-danger': variant === 'danger', 'background-secondary': variant === 'secondary'}"
        :style="{ padding: `${padding}px`, overflow }"
      >
        <button
          type="button"
          class="close"
          :class="{ 'button-close-secondary': variant === 'secondary' }"
          data-dismiss="modal"
          aria-label="Close"
          @click="$emit('close')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
const variants = ['default', 'danger', 'secondary']

/**
 * Модальное окно.
 */
export default {
  name: 'CModal',
  props: {
    /**
     * Идентификатор.
     */
    id: {
      type: String,
      required: true
    },
    /**
     * Добавляет класс container-fluid.
     */
    fluid: {
      type: Boolean,
      default: false
    },
    /**
     * CSS-свойство overflow для .modal-content.
     */
    overflow: {
      type: String,
      default: 'visible'
    },
    /**
     * Padding в px для .modal-content.
     */
    padding: {
      type: Number,
      default: 10
    },
    /**
     * Вариант цветового оформления.
     */
    variant: {
      type: String,
      validator (value) {
        return variants.includes(value)
      },
      default: 'default'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.modal-danger {
  background-color: $textDangerColor;
}

.background-secondary {
  background-color: $sidebarBackgroundColor;
}

.modal button.close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  font-size: 35px;
}

.button-close-secondary {
  color: #BBBBBB;
}
</style>
